export default __webpack_public_path__ + "static/media/480_business02-nl-web.20552cce.png";